import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TermsHtml } from "../../api/modules/b2droppie.class";
import { toggleLoader } from "../../redux/slices/loaderSlice";
import BackdropLoader from "../../components/BackdropLoader/BackdropLoader";

const Terms = () => {
  const dispatch = useDispatch();
  const [terms, setTerms] = useState();
  const isLoading = useSelector((state) => state?.loader?.isLoading);

  useEffect(() => {
    try {
      dispatch(toggleLoader({ isLoading: true }));
      TermsHtml()
        .then((response) => {
          setTerms(response?.data?.data);
          dispatch(toggleLoader({ isLoading: false }));
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log("Failed", e);
    }
  }, []);

  return isLoading ? (
    <BackdropLoader show={isLoading} />
  ) : (
    <Container className="px-5 py-5">
      <h1 className="text-center p-3">Terms and Conditions</h1>
      {terms
        ? terms?.map((item, index) => (
            <div
            style={{textAlign:"left"}}
              key={index}
              dangerouslySetInnerHTML={{ __html: item?.description }}
            />
          ))
        : null}
    </Container>
  );
};

export default Terms;
